import Vue from 'vue';

$( window ).on( 'elementor/frontend/init', function() {
    //hooks into elementor, fires in front end and in elementor editor
    //action name is frontend/element_ready/{name-of-widget}.default
    elementorFrontend.hooks.addAction('frontend/element_ready/podcasts-list.default', function ($scope, $) {


        //podcast list and filter vue app

        sf_podcasts_widget($scope.find('.podcasts-widget'));

        //podcasts video cover
        //todo, does this make sense now, or should we just handle it in vuejs?
        //we still need the jquery version for the single podcast (serverside) template
        $scope.find('.podcast').each(function (i, p) {
            sf_podcast_cover_click($(p), $);
        })

    });
});
//podcasts vuejs app

function sf_podcasts_widget(app_root){

    console.log('in sf_podcasts_widget function');
    var podcasts = app_root.data('podcasts');
    var topics = app_root.data('topics');
    var app = new Vue({
        el: app_root.get(0),
        data: {
            podcasts: podcasts,
            topics:topics,
            searchTerm:'',
            showTopicsPanel:false,
            filterTopics:[],
            currentPage: 1,
            itemsPerPage: 12
        },
        methods:{
            clearAll(){
                this.searchTerm='';
                this.filterTopics=[];
            },
            goToPage(page){
                this.currentPage = page;
            },
            nextPage(){
                if (this.currentPage < this.totalPages) this.currentPage++;
            },
            prevPage(){
                if (this.currentPage > 1) this.currentPage--;
            }
        },

        watch: {
            filteredPodcasts() {
                this.currentPage = 1;
            }
        },

        computed:{
            filteredPodcasts(){
                if(
                    this.searchTerm ==  ''
                    && this.filterTopics.length==0
                ){
                    return this.podcasts;
                }
                return this.podcasts.filter(podcast =>{
                    //all filters should match. End early if not
                    if(this.searchTerm !==  '' && !podcast.smart_search.toLowerCase().includes(this.searchTerm.toLowerCase())){
                        return false; //no match
                    }
                    //match any topic
                    if(this.filterTopics.length >=1 && !this.filterTopics.some(s=>podcast.tags.includes(s))){
                        return false; //no match
                    }
                    return true;
                });
            },
            paginatedPodcasts(){
                const start = (this.currentPage - 1) * this.itemsPerPage;
                const end = start + this.itemsPerPage;
                return this.filteredPodcasts.slice(start, end);
            },
            totalPages(){
                return Math.ceil(this.filteredPodcasts.length / this.itemsPerPage);
            },
            showingStart(){
                return (this.currentPage - 1) * this.itemsPerPage + 1;
            },
            showingEnd(){
                return Math.min(this.currentPage * this.itemsPerPage, this.filteredPodcasts.length);
            }
        }

    });
}


//plain function, since this appears in templates as well as widgets
function sf_podcast_cover_click($scope, $s){
    //alert('pp');
    var video_cover  = $scope.find('.js-podcast__video-cover');
    video_cover.on('click', function (ev) {

        ev.preventDefault();
        var iframe = $scope.find('.js-podcast__video-iframe');
        iframe.attr('src', iframe.attr('src') + '&autoplay=1');
        video_cover.hide();
    })
}

( function( $ ) {
    window.$ = $;

    //target only serverside generated, pos conflict with vue generated?
    $('.js-podcast-single').each(function (i, p) {
        sf_podcast_cover_click($(p), $);
    })

    function open_transcript() {
        $('.podcast__transcript').toggleClass('podcast__transcript--open');
        $('.podcast__transcript-content').slideToggle();
    }

    $('.podcast__transcript-toggle').click(function(ev) {
        ev.preventDefault();

        open_transcript();
    });

    if (window.location.hash == '#transcript') {
        open_transcript();
    }

})(( jQuery ));
